/**
 * The public URL of one forum: `/comunitate/forumuri/<slug>`.
 *
 * Same shape as eventPath.ts: the slug comes straight from the API, assigned once at creation
 * from the title and never recomputed, so a link stays valid even if the forum is later renamed.
 */
export function forumPath(forum: { slug: string }): string {
  return `/comunitate/forumuri/${forum.slug}`;
}
